import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowLeft, Download, ArrowDown } from "lucide-react";
import { MaskLines, Reveal } from "../site/Reveal";
import { scrollToId } from "../site/SmoothScroll";

export const ProductBanner = ({ r }) => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 800], [0, 140]);
  return (
    <>
      <section data-testid="product-hero" className="relative min-h-[620px] h-[86svh] max-h-[860px] overflow-hidden bg-[var(--forest)]">
        <motion.img style={{ y }} initial={{ scale: 1.12 }} animate={{ scale: 1 }} transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }} src={r.banner} alt={r.species} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,40,26,0.93)_0%,rgba(0,40,26,0.7)_45%,rgba(0,40,26,0.2)_85%)]" />
        <div className="relative h-full mx-auto max-w-[1400px] px-5 md:px-10 flex flex-col justify-center pt-32 pb-24">
          <Link to="/#ranges" data-testid="product-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white"><ArrowLeft size={15} /> All solutions</Link>
          <p className="mt-6 text-[13px] font-bold uppercase tracking-[0.2em] text-[var(--lime)]">{r.category} · {r.species}</p>
          <MaskLines testId="product-title" className="font-display text-white text-5xl sm:text-7xl lg:text-[6.5rem] leading-[0.95] mt-4" lines={[r.name]} />
          <MaskLines as="p" delay={0.3} className="font-display text-[var(--lime)] text-2xl md:text-4xl mt-3" lines={[r.tagline]} />
          <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="mt-5 text-base md:text-lg text-[#DCEBE0] max-w-xl leading-relaxed">{r.lead}</motion.p>
          <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.85 }} className="mt-8 flex flex-col sm:flex-row gap-3">
            <button onClick={() => scrollToId("enquire")} data-testid="product-quote-button" className="inline-flex justify-center items-center gap-2 bg-[var(--lime)] text-[var(--forest)] px-7 py-4 rounded-md font-bold">
              Request a quote <ArrowDown size={18} />
            </button>
            <a href={r.brochure} download data-testid="product-brochure-button" className="inline-flex justify-center items-center gap-2 border-2 border-white/80 text-white px-7 py-4 rounded-md font-bold hover:bg-white hover:text-[var(--forest)] transition-colors">
              <Download size={16} /> Technical brochure
            </a>
          </motion.div>
        </div>
      </section>
      <section className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 -mt-16">
        <div className="bg-white rounded-[10px] shadow-[0_30px_60px_-30px_rgba(0,40,26,0.45)] border border-[var(--line)] grid grid-cols-1 md:grid-cols-12 overflow-hidden">
          <div className="md:col-span-3 bg-[var(--paper)] h-56 md:h-auto relative">
            <img src={r.pack} alt={`${r.name} pack`} className="absolute inset-0 h-full w-full object-cover" />
          </div>
          <div className="md:col-span-9 grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[var(--line)]">
            {r.stats.map((s, i) => (
              <Reveal key={s.l} delay={i * 0.08} className="p-6 md:p-8">
                <p data-testid={`product-stat-${i}`} className="font-display text-4xl md:text-5xl" style={{ color: r.accent }}>{s.v}</p>
                <p className="text-sm text-[var(--muted)] mt-2">{s.l}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
